<div class="card detail">
  <div class="card-header">
    <div class="action-btn">
      <ng-container *ngIf="!isThreeD && !isFacade">
        <span class="btn btn-sm btn-tool" id="draw_polygon" (click)="toggleDraw('draw_polygon')" [class.text-success]="isDraw === 'draw_polygon'" [class.disable]="disableMapboxDraw">
          <i class="icon-annotation"></i>
          <span class="tooltip-text" style="margin-top: -4em; margin-left: -.2em">{{'Polygon' | translate}}</span>
        </span>
        <span class="btn btn-sm btn-tool" id="draw_rect" (click)="toggleDraw('draw_rect')" [class.text-success]="isDraw === 'draw_rect'" [class.disable]="disableMapboxDraw">
          <i class="icon-box"></i>
          <span class="tooltip-text" style="margin-top: -4em; margin-left: -.2em">{{'Square' | translate}}</span>
        </span>
        <span class="btn btn-sm btn-tool" id="draw_circle" (click)="toggleDraw('draw_circle')" [class.text-success]="isDraw === 'draw_circle'" [class.disable]="disableMapboxDraw">
          <i class="icon-circle" data-cy="toolkitMenuCircle"></i>
          <span class="tooltip-text" style="margin-top: -4em; margin-left: -.2em">{{'Circle' | translate}}</span>
        </span>
        <span class="btn btn-sm btn-tool" id="draw_line_string" (click)="toggleDraw('draw_line_string')" [class.text-success]="isDraw === 'draw_line_string'" [class.disable]="disableMapboxDraw">
          <i class="icon-measure"></i>
          <span class="tooltip-text" style="margin-top: -4em; margin-left: -.2em">{{'Draw Line' | translate}}</span>
        </span>
      </ng-container>

      <ng-container *ngIf="isFacade">
        <span class="btn btn-sm btn-tool" [class.text-success]="openlayerDrawmode === 'Point'"  (click)="olDrawMode('Point')" id="draw_polygon" [class.disable]="disableMapboxDraw">
          <i class="icon-location-marker"></i>
          <span class="tooltip-text" style="margin-top: -4em; margin-left: -.2em">{{'Point' | translate}}</span>
        </span>
        <span class="btn btn-sm btn-tool" [class.text-success]="openlayerDrawmode === 'LineString'"  (click)="olDrawMode('LineString')" id="draw_line_string" [class.disable]="disableMapboxDraw">
          <i class="icon-measure"></i>
          <span class="tooltip-text" style="margin-top: -4em; margin-left: -.2em">{{'Draw Line' | translate}}</span>
        </span>
        <span class="btn btn-sm btn-tool" [class.text-success]="openlayerDrawmode === 'Polygon'"  (click)="olDrawMode('Polygon')" id="draw_polygon" [class.disable]="disableMapboxDraw">
          <i class="icon-annotation"></i>
          <span class="tooltip-text" style="margin-top: -4em; margin-left: -.2em">{{'Polygon' | translate}}</span>
        </span>
        <span class="btn btn-sm btn-tool" [class.text-success]="openlayerDrawmode === 'Square'"  (click)="olDrawMode('Square')" id="draw_square" [class.disable]="disableMapboxDraw">
          <i class="icon-box"></i>
          <span class="tooltip-text" style="margin-top: -4em; margin-left: -.2em">{{'Square' | translate}}</span>
        </span>
        <span class="btn btn-sm btn-tool" [class.text-success]="openlayerDrawmode === 'Box'"  (click)="olDrawMode('Box')" id="draw_box" [class.disable]="disableMapboxDraw">
          <i class="icon-box"></i>
          <span class="tooltip-text" style="margin-top: -4em; margin-left: -.2em">{{'Box' | translate}}</span>
        </span>
        <span class="btn btn-sm btn-tool" [class.text-success]="openlayerDrawmode === 'Circle'"  (click)="olDrawMode('Circle')" id="draw_circle" [class.disable]="disableMapboxDraw">
          <i class="icon-circle" data-cy="toolkitMenuCircle"></i>
          <span class="tooltip-text" style="margin-top: -4em; margin-left: -.2em">{{'Circle' | translate}}</span>
        </span>
      </ng-container>
      <!-- <span class="btn btn-sm">
        <i class="icon-pointer"></i>
      </span> -->
      <!-- <span class="btn btn-sm">
        <i class="icon-text"></i>
      </span> -->
      <ng-container *ngIf="isThreeD">
        <span class="btn btn-sm btn-tool" (click)="activateTool('measure-distance')" [class.text-success]="isDraw === 'measure-distance'">
          <i class="icon-measure"></i>
          <span class="tooltip-text" style="margin-top: -4em; margin-left: -.2em">{{'Distance' | translate}}</span>
        </span>
        <span class="btn btn-sm btn-tool" (click)="activateTool('measure-height')" [class.text-success]="isDraw === 'measure-height'">
          <i class="icon-measure" style="transform: rotate(90deg);"></i>
          <span class="tooltip-text" style="margin-top: -4em; margin-left: -.2em">{{'Height' | translate}}</span>
        </span>
        <span class="btn btn-sm btn-tool" (click)="activateTool('measure-point')" [class.text-success]="isDraw === 'measure-point'">
          <i class="icon-reference-image"></i>
          <span class="tooltip-text" style="margin-top: -4em; margin-left: -.2em">{{'Reference Images' | translate}}</span>
        </span>
        <span class="btn btn-sm btn-tool" (click)="activateTool('measure-angle')" [class.text-success]="isDraw === 'measure-angle'">
          <i class="icon-angles"></i>
          <span class="tooltip-text" style="margin-top: -4em; margin-left: -.2em">{{'Angle' | translate}}</span>
        </span>
        <!-- <span class="btn btn-sm" (click)="activateTool('measure-circle')" [class.text-success]="isDraw === 'draw_circle'">
          <i class="icon-circle"></i>
        </span> -->
        <span class="btn btn-sm btn-tool" (click)="activateTool('measure-area')" [class.text-success]="isDraw === 'measure-area'">
          <i class="icon-annotation-box"></i>
          <span class="tooltip-text" style="margin-top: -4em; margin-left: -.2em">{{'Area' | translate}}</span>
        </span>
      </ng-container>
      <!-- <span class="btn btn-sm">
        <i class="icon-location-marker"></i>
      </span> -->
      <!-- <span class="btn btn-sm">
        <i class="icon-rotate-box"></i>
      </span> -->
      <span class="btn btn-sm btn-tool" id="delete_draw" (click)="deleteAnnotation()">
        <i class="icon-recycle"></i>
        <span class="tooltip-text" style="margin-top: -4em">{{'Delete' | translate}}</span>
      </span>
    </div>
  </div>
</div>
